import useCrud from 'hooks/useCrud';
import { useCallback } from 'react';
import { sceneList } from 'services/api/remind';

function useScene() {
  return useCrud({
    readList: useCallback(() => sceneList().then((res) => res.remindScenes), []),
  });
}

export default useScene;
